export default "__VITE_ASSET__RnLW8BE$__"